/**
 * CargasTable — lista de cargas (RF-M2-010): Carga, Recebida em, Origem,
 * Arquivos, Novos × Duplicados, Status. Cada linha abre o relatório (onDetalhe).
 */

import { CargaListItem } from '../services/cargas-types';
import { classeStatus, formatarData, rotuloStatus } from './format';

export interface CargasTableProps {
  readonly itens: readonly CargaListItem[];
  readonly onDetalhe: (id: string) => void;
}

export function CargasTable({ itens, onDetalhe }: CargasTableProps): JSX.Element {
  if (itens.length === 0) {
    return <p className="muted">Nenhuma carga registrada ainda.</p>;
  }
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Carga</th>
          <th>Recebida em</th>
          <th>Origem</th>
          <th>Arquivos</th>
          <th>Novos × Duplicados</th>
          <th>Status</th>
          <th aria-label="ações" />
        </tr>
      </thead>
      <tbody>
        {itens.map((c) => (
          <tr key={c.cargaId}>
            <td className="mono">{c.cargaId.slice(0, 8)}</td>
            <td>{formatarData(c.data)}</td>
            <td>{c.origem === 'SCRIPT' ? 'Script' : 'Navegador'}</td>
            <td>{c.totalArquivos}</td>
            <td>
              {c.novos} × {c.duplicados}
            </td>
            <td>
              <span className={classeStatus(c.status)}>{rotuloStatus(c.status)}</span>
            </td>
            <td>
              <button type="button" className="btn btn-ghost" onClick={() => onDetalhe(c.cargaId)}>
                Relatório
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
